import React from 'react';
import { Hero } from '../components/Hero';
import { Marquee } from '../components/Marquee';
import { MiniSlider } from '../components/MiniSlider';
import { About } from '../components/About';
import { Founder } from '../components/Founder';
import { Impact } from '../components/Impact';
import { Gallery } from '../components/Gallery';
import { Programs } from '../components/Programs';
import { Donate } from '../components/Donate';
import { Contact } from '../components/Contact';
export function Home() {
  return <main className="flex-grow" data-id="element-459" data-mp="24i3fi2l80tlo">
      <Hero data-id="element-460" data-mp="24hagxowf1aem" />
      <Marquee data-id="element-461" data-mp="24ivd1iydp1el" />
      <MiniSlider data-id="element-462" data-mp="29g51owdy191d" />
      <About data-id="element-463" data-mp="29fvj3tv8a45p" />
      <Founder data-id="element-464" data-mp="29f264b5oeif4" />
      <Impact data-id="element-465" data-mp="29ek4t045pe0c" />
      <Gallery data-id="element-466" data-mp="29i7yq0dik2fl" />
      <Programs data-id="element-467" data-mp="29ihmdhb35xi4" />
      <Donate data-id="element-468" data-mp="2dhgo6t1ite5c" />
      <Contact data-id="element-469" data-mp="2dhyvckpq1cs1" />
    </main>;
}